define([
    "jquery",
    "underscore",
    "marionette",
    "jquery.fileupload",
], function($, _, Marionette) {
    return Marionette.View.extend({
        el: '#header_layout',

        ui:{
            'flags': '#flags_dropdown',
            'closeFlags': '.close_flags_dropdown',
            'openFlags': '.open_flags_dropdown',
            'uploadAvatarFile': '#upload_avatar_file',
            'avatar': '#avatar',
            'removeAvatar': '#remove_avatar',
            'closeCopyTradingBanner': '.copy-trading-banner-close',
            'copyTradingBanner': '.copy-trading-banner',
            'roiBanner': '.roi-banner',
            'closeRoiBanner': '.roi-banner-close',
        },

        events:{
            'click @ui.closeFlags': 'toggleFlags',
            'click @ui.openFlags': 'toggleFlags',
            'click @ui.closeCopyTradingBanner': 'hideCopyTradingBanner',
            'click @ui.closeRoiBanner': 'hideRoiBanner'
        },

        initialize: function(){
            this.bindUIElements();

            this.initFileUpload(this.ui.uploadAvatarFile);
        },

        toggleFlags: function(e){
            if(e) e.preventDefault();
            this.ui.flags.slideToggle( "slow", function() {
                // Animation complete.
            });
        },

        hideCopyTradingBanner: function (e){
            if(e) e.preventDefault();
            this.ui.copyTradingBanner.slideToggle( "slow", function() {
                // Animation complete.
            });
        },

        hideRoiBanner: function () {
            this.ui.roiBanner.slideToggle("slow", function() {});
        },

        initFileUpload: function($selector){
            var that = this;
            $selector.fileupload({
                url: '/rest_profile/avatar',
                dataType: 'json',
                add: function(e, data){
                    HoldOn.open({
                        theme:"sk-fading-circle"
                    });
                    data.submit();
                },
                done: function(e, data){
                    that.ui.avatar.attr('src','/common/show_avatar?file='+data.jqXHR.responseJSON.file_path);

                    HoldOn.close();
                },
                fail: function(e, data){
                    HoldOn.close();
                }
            });
        }
    });
});